import React, { Component, Fragment } from 'react';
import { isNullOrEmpty } from '../../helpers/LanguageHelpers';


import resImage from '../../content/resPicture96.png';
import resVideo from '../../content/resVideo96.png';
import resAudio from '../../content/resAudio96.png';
import resDoc from '../../content/resDoc96.png';
import resWeb from '../../content/resWeb96.png';

/*
 * CadeResourceIcons work in conjunction with CadeResourceModal.
 * Icons provide a visual interface for the different resources.  They also accept a click on the resource but then handoff processing that click to the caller.
 * 
 * Note:  The caller must maintain a dictionary of resources ({resKey, resourceArray}) and handling clicks on individual resource icons by determining which resource was clicked (by resKey and resType ) 
 *        and then interacting with the CadeResourceModal component to display a modal window for the resource.
 */

class CadeResourceIcons extends Component {

    render() {

        // Display only those resource types provided in the resources array (an array of resource objects)
        let displayDocIcon = false;
        let displayimageIcon = false;
        let displayAudioIcon = false;
        let displayVideoIcon = false;
        let displayWebIcon = false;
        let res = null;
        if (!isNullOrEmpty(this.props.resources)) {
            for (let i = 0; i < this.props.resources.length; i++) {
                res = this.props.resources[i];
                switch (res.type) {
                    case 1:
                        displayDocIcon = true;
                        break;

                    case 2:
                        displayimageIcon = true;
                        break;

                    case 3:
                        displayAudioIcon = true;
                        break;

                    case 4:
                        displayVideoIcon = true;
                        break;

                    case 5:
                        displayWebIcon = true;
                        break;

                    default:
                        break;
                }
            }
        }

        return (
            <Fragment>
                <div className="cadeResource_iconContainer">
                    {displayimageIcon &&
                        <img className="cadeResource_icon" src={resImage} alt="Domain resource" height={this.props.size} onClick={() => this.props.clickHandler(this.props.resKey, 2)} />
                    }
                    {displayVideoIcon &&
                        <img className="cadeResource_icon" src={resVideo} alt="Domain resource" height={this.props.size} onClick={() => this.props.clickHandler(this.props.resKey, 4)} />
                    }
                    {displayAudioIcon &&
                        <img className="cadeResource_icon" src={resAudio} alt="Domain resource" height={this.props.size} onClick={() => this.props.clickHandler(this.props.resKey, 3)} />
                    }
                    {displayDocIcon &&
                        <img className="cadeResource_icon" src={resDoc} alt="Domain resource" height={this.props.size} onClick={() => this.props.clickHandler(this.props.resKey, 1)} />
                    }
                    {displayWebIcon &&
                        <img className="cadeResource_icon" src={resWeb} alt="Domain resource" height={this.props.size} onClick={() => this.props.clickHandler(this.props.resKey, 5)} />
                    }
                </div>
            </Fragment>
        )
    }
}

export default CadeResourceIcons;


// WEBPACK FOOTER //
// ./src/components/CadeResource/CadeResourceIcons.js